import { render, staticRenderFns } from "./ShopInfoSelector.vue?vue&type=template&id=4cfaea1c&scoped=true"
import script from "./ShopInfoSelector.vue?vue&type=script&lang=js"
export * from "./ShopInfoSelector.vue?vue&type=script&lang=js"
import style0 from "./ShopInfoSelector.vue?vue&type=style&index=0&id=4cfaea1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfaea1c",
  null
  
)

export default component.exports